import { render, staticRenderFns } from "./ImportJobDescriptionIQOverlay.vue?vue&type=template&id=6a8efe2a&scoped=true"
import script from "./ImportJobDescriptionIQOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./ImportJobDescriptionIQOverlay.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ImportJobDescriptionIQOverlay.vue?vue&type=style&index=0&id=6a8efe2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8efe2a",
  null
  
)

export default component.exports